export const getPageNumberFromMap = (
  map: Map<string, number>,
  paginationRangeLimit: "min" | "max" = "min",
): number => {
  const listOfValues = Array.from(map.values());
  return paginationRangeLimit === "min"
    ? listOfValues[0]
    : listOfValues[listOfValues.length - 1];
};
